// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"c3c7b2bc","362":"31d6cfe0"}[chunkId] + ".chunk.css";
};